var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app",class:[_vm.className, _vm.getPlatformInfo],attrs:{"id":"app"}},[_c('alert-sticky-bar'),_c(_vm.layoutName,{tag:"component",nativeOn:{"click":function($event){return _vm.hideAllLayers.apply(null, arguments)}}}),_c('dialogs-wrapper',{attrs:{"tag":"div"}}),_c('dialogs-wrapper',{attrs:{"tag":"div","name":"error"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }